import "bootstrap/dist/css/bootstrap.min.css";
import GenericTable from "components/tables/GenericTable";
import React from "react";
import { Card, Col } from "react-bootstrap";

const GNSSSimultaneousMajorFailures = ({ innerRef, data }) => {
  return (
    <>
      <Card.Title as="h6" ref={innerRef}>
        Probability of simultaneous major failures of two or more satellites
      </Card.Title>
      <Card.Body>
        <p className="text-justify">
          The probability of simultaneous major failures of two or more
          satellites is calculated in the same conditions as the probability of
          major service failure. It includes the probability of two or more
          independent, unannounced single failures occurring at any time, and
          the probability of two or more dependent satellite failures.
        </p>
        <p className="text-justify">
          {" "}
          Number of simultaneous major failures (SF) of two or more satellites
        </p>
        <Col>
          <GenericTable data={data.smsfTable} />
          <p className="text-justify">
            There are no SF events in the reporting period.
          </p>
        </Col>
      </Card.Body>
    </>
  );
};

export default React.memo(
  React.forwardRef((props, ref) => (
    <GNSSSimultaneousMajorFailures innerRef={ref} {...props} />
  ))
);
